const initialState = {
  accounts: [],
  error: "",
};

export default initialState;
